import { FEEDER_KINDS } from '../../types/SimpleSupplyPoint';

/**
 * Feeder varsayılan şablonları
 * Farklı feeder tipleri için standart kablo ve elektriksel ayarlar
 */
export const FEEDER_TEMPLATES = {

  // ===============================
  // MAIN FEEDER (Ana Besleyici)
  // Template sadece sabit kurallar ve minimum değerleri içerir
  // phaseCount, voltage gibi kullanıcıya bağlı değerler factory'de hesaplanır
  // ===============================
  [FEEDER_KINDS.MAIN_FEEDER]: {
    cable: {
      type: 'NYY',
      minSection: 6,        // ✅ Minimum kablo kesiti (mm²)
      material: 'Cu',
      color: 'black',
      // sectionCount phaseCount'a göre factory'de hesaplanır:
      // 3 Faz: 4 (3F+N), 1 Faz: 2 (F+N)
      // coreCount: Paralel kablo sayısı (default: 1)
      hasNeutral: true,     // ✅ Ana besleyicide nötr zorunlu
      hasGrounding: false   // ✅ Ana besleyicide toprak iletkeni YOK (sadece F+N)
    },
    electrical: {
      // voltage ve phaseCount kullanıcıdan gelir, template'te yok
      minCurrent: 25,       // ✅ Minimum akım kapasitesi
      powerFactor: 0.9
    },
    protection: {
      mcb: {
        minCurrent: 25,              // ✅ Minimum kesici akımı
        shortCircuitCurCap: 10,  // ✅ 10kA kırma kapasitesi
        curve: 'C',
        neutralBreaking: false       // ✅ Ana sayaçta nötr kesmez
      },
      rcd: {
        sensitivity: 300,    // ✅ Yangın koruma (sabit)
        type: 'AC'
      }
    },
    metadata: {
      standards: 'IEC',
      region: 'Turkey',
      installationType: 'underground'
    }
  },

  // ===============================
  // DIST FEEDER (Dağıtım Besleyici: meter_panel → dist_panel)
  // ===============================
  [FEEDER_KINDS.DIST_FEEDER]: {
    cable: {
      type: 'NYM',
      minSection: 4,        // ✅ Minimum kablo kesiti (mm²)
      material: 'Cu',
      color: 'black',
      // sectionCount phaseCount'a göre factory'de hesaplanır:
      // 3 Faz: 5 (3F+N+PE), 1 Faz: 3 (F+N+PE)
      hasNeutral: true,     // ✅ Nötr zorunlu
      hasGrounding: true    // ✅ Topraklama zorunlu
    },
    electrical: {
      // voltage ve phaseCount kullanıcıdan gelir, template'te yok
      minCurrent: 25,       // ✅ Minimum akım kapasitesi
      powerFactor: 0.9
    },
    protection: {
      mcb: {
        minCurrent: 25,                // ✅ Minimum kesici akımı
        shortCircuitCurCap: 10,     // ✅ 10kA kırma kapasitesi
        curve: 'B',
        type: 'AOS',
        neutralBreaking: true          // ✅ Nötr keser (feeder'larda)
      },
      rcd: {
        sensitivity: 30,     // ✅ 30mA koruma
        type: 'A'
      }
    },
    metadata: {
      standards: 'IEC',
      region: 'Turkey',
      installationType: 'cable_tray'
    }
  },

  // ===============================
  // BRANCH CIRCUIT (Dal Devresi)
  // ===============================
  [FEEDER_KINDS.BRANCH_CIRCUIT]: {
    cable: {
      type: 'NYM',
      minSection: 2.5,      // ✅ Minimum kablo kesiti (mm²)
      material: 'Cu',
      color: 'white',
      hasNeutral: true,
      hasGrounding: true
    },
    electrical: {
      // voltage ve phaseCount kullanıcıdan gelir
      minCurrent: 16,       // ✅ Minimum akım
      powerFactor: 0.9
    },
    protection: {
      mcb: {
        minCurrent: 16,
        shortCircuitCurCap: 3,
        curve: 'B',
        type: 'AOS',
        neutralBreaking: true          // ✅ Nötr keser
      },
      rcd: {
        sensitivity: 30,
        type: 'A'
      }
    },
    metadata: {
      standards: 'IEC',
      region: 'Turkey',
      installationType: 'conduit'
    }
  },

  // ===============================
  // PANEL FEEDER (Panel Besleyici)
  // ===============================
  [FEEDER_KINDS.PANEL_FEEDER]: {
    cable: {
      type: 'NYM',
      minSection: 4,        // ✅ Minimum kablo kesiti (mm²)
      material: 'Cu',
      color: 'black',
      // sectionCount phaseCount'a göre factory'de hesaplanır:
      // 3 Faz: 5 (3F+N+PE), 1 Faz: 3 (F+N+PE)
      hasNeutral: true,     // ✅ Nötr zorunlu
      hasGrounding: true    // ✅ Topraklama zorunlu
    },
    electrical: {
      // voltage ve phaseCount kullanıcıdan gelir, template'te yok
      minCurrent: 25,       // ✅ Minimum akım kapasitesi
      powerFactor: 0.9
    },
    protection: {
      mcb: {
        minCurrent: 25,                // ✅ Minimum kesici akımı
        shortCircuitCurCap: 10,     // ✅ 10kA kırma kapasitesi
        curve: 'B',
        type: 'AOS',
        neutralBreaking: true          // ✅ Nötr keser (feeder'larda)
      },
      rcd: {
        sensitivity: 30,     // ✅ 30mA koruma
        type: 'A'
      }
    },
    metadata: {
      standards: 'IEC',
      region: 'Turkey',
      installationType: 'cable_tray'
    }
  },

  // ===============================
  // SOCKET CIRCUIT (Priz Devresi)
  // ===============================
  [FEEDER_KINDS.SOCKET_CIRCUIT]: {
    cable: {
      type: 'NYM',
      minSection: 2.5,      // ✅ Minimum kablo kesiti (mm²)
      material: 'Cu',
      color: 'white',
      hasNeutral: true,
      hasGrounding: true
    },
    electrical: {
      // voltage ve phaseCount kullanıcıdan gelir
      minCurrent: 16,       // ✅ Minimum akım
      powerFactor: 0.9
    },
    protection: {
      mcb: {
        minCurrent: 16,
        shortCircuitCurCap: 3,
        curve: 'B',
        type: 'AOS',
        neutralBreaking: true          // ✅ Nötr keser
      },
      rcd: {
        sensitivity: 30,
        type: 'A'
      }
    },
    metadata: {
      standards: 'IEC',
      region: 'Turkey',
      installationType: 'conduit'
    }
  },

  // ===============================
  // LIGHTING CIRCUIT (Aydınlatma Devresi)
  // ===============================
  [FEEDER_KINDS.LIGHTING_CIRCUIT]: {
    cable: {
      type: 'NYM',
      minSection: 1.5,      // ✅ Minimum kablo kesiti (mm²)
      material: 'Cu',
      color: 'blue',
      hasNeutral: true,
      hasGrounding: true
    },
    electrical: {
      // voltage ve phaseCount kullanıcıdan gelir
      minCurrent: 10,       // ✅ Minimum akım
      powerFactor: 0.9
    },
    protection: {
      mcb: {
        minCurrent: 10,
        shortCircuitCurCap: 3,
        curve: 'B',
        type: 'AOS',
        neutralBreaking: true          // ✅ Nötr keser
      }
      // Lighting circuit'inde RCD zorunlu değil
    },
    metadata: {
      standards: 'IEC',
      region: 'Turkey',
      installationType: 'conduit'
    }
  },

  // ===============================
  // MACHINE CIRCUIT (Makine Devresi)
  // ===============================
  [FEEDER_KINDS.MACHINE_CIRCUIT]: {
    cable: {
      type: 'NYA',
      minSection: 2.5,      // ✅ Minimum kablo kesiti (mm²)
      material: 'Cu',
      color: 'black',
      hasNeutral: true,
      hasGrounding: true
    },
    electrical: {
      // voltage ve phaseCount kullanıcıdan gelir
      minCurrent: 20,       // ✅ Minimum akım
      powerFactor: 0.8      // Makine için daha düşük PF
    },
    protection: {
      mcb: {
        minCurrent: 16,
        shortCircuitCurCap: 3,   // ✅ Bulaşık/çamaşır makineleri için 6kA
        curve: 'B',                  // Makine için B eğrisi
        type: 'AOS',
        neutralBreaking: false        // ✅ Nötr kesmez
      }
      // Machine circuit'inde RCD opsiyonel
    },
    metadata: {
      standards: 'TSE',
      region: 'Turkey',
      installationType: 'cable_tray'
    }
  },

  // ===============================
  // LOWCURRENT CIRCUIT (Zayıf Akım Devresi - Zil, Telefon vb.)
  // ===============================
  [FEEDER_KINDS.LOWCURRENT_CIRCUIT]: {
    cable: {
      type: 'NYM',
      section: 1.5, // mm²
      sectionCount: 2, // 2x1.5
      coreCount: 2,
      material: 'Cu',
      insulation: 'PVC',
      color: 'white',
      indexNo: 1 // CABLES[1] = Bell cable
    },
    electrical: {
      voltage: 12,
      current: 1, // Amper
      maxCurrent: 2,
      powerFactor: 1.0,
      phaseCount: 1
    },
    protection: {
      mcb: {
        type: 'B',
        current: 16,
        curve: 'B',
        shortCircuitCurCap: 3
      }
    },
    metadata: {
      standards: 'IEC',
      region: 'Turkey',
      installationType: 'conduit'
    }
  }
};

/**
 * Feeder tipi için varsayılan şablonu döndürür
 */
export function getFeederTemplate(kind) {
  const template = FEEDER_TEMPLATES[kind];
  if (!template) {
     return null;
  }

  // Deep copy to prevent mutation
  return JSON.parse(JSON.stringify(template));
}

/**
 * Yük tipine göre uygun feeder şablonunu seçer
 */
export function getFeederTemplateByLoadType(loadType, power = 0) {
  switch (loadType) {
    case 'socket':
      return getFeederTemplate(FEEDER_KINDS.SOCKET_CIRCUIT);

    case 'lighting':
      return getFeederTemplate(FEEDER_KINDS.LIGHTING_CIRCUIT);

    case 'machine':
      // Güce göre kablo kesiti ayarla
      const template = getFeederTemplate(FEEDER_KINDS.MACHINE_CIRCUIT);
      if (power > 5000) {
        template.cable.section = 6; // mm²
        template.electrical.current = 25;
      }
      return template;

    case 'panel':
      return getFeederTemplate(FEEDER_KINDS.PANEL_FEEDER);

    case 'bell':
      // Zil tesisatı için özel template - 12V, küçük kesit
      return {
        ...getFeederTemplate(FEEDER_KINDS.BRANCH_CIRCUIT),
        cable: {
          type: 'Bell Cable 2x0.5',
          section: 0.5,
          sectionCount: 2,
          material: 'CU',
          insulation: 'PVC',
          indexNo: 'B1'
        },
        electrical: {
          voltage: 12,
          current: 0.5,
          maxCurrent: 1,
          phaseCount: 1,
          installedPower: 5
        }
      };

    default:
      return getFeederTemplate(FEEDER_KINDS.BRANCH_CIRCUIT);
  }
}

/**
 * Mevcut feeder'ı template ile karşılaştır ve eksik alanları tamamla
 */
export function validateAndCompleteFeeder(feeder) {
  const template = getFeederTemplate(feeder.kind);
  if (!template) return feeder;

  return {
    ...template,
    ...feeder,
    cable: {
      ...template.cable,
      ...feeder.cable
    },
    electrical: {
      ...template.electrical,
      ...feeder.electrical
    },
    protection: {
      ...template.protection,
      ...feeder.protection
    },
    metadata: {
      ...template.metadata,
      ...feeder.metadata
    }
  };
}